import { ENDPOINT_AI } from '../config'
import {  buildReindexParams } from './postReindex'
import type {PostReindexRequest} from './postReindex';
import type { AiReindexResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Pre-flight dryRun. Hits POST /ai/index with ?dryRun=true so the backend
 * computes the lower-bound estimate WITHOUT queuing a Hangfire job, writing
 * a ReindexJob row, or burning a quota reservation. Always returns 200 (the
 * 409 over-quota gate is the confirm path's behaviour, not dryRun's).
 *
 * `wouldExceedQuota` on the response tells the UI whether to show the
 * cost-confirm checkbox before the user clicks the real reindex button.
 */
export async function postReindexEstimate(
  workspaceSlug: string,
  request: Omit<PostReindexRequest, 'confirmCost'> = {},
): Promise<AiReindexResponse> {
  const params = buildReindexParams({ ...request, dryRun: true })
  const response = await AuthAxios.post<AiReindexResponse>(
    `${ENDPOINT_AI(workspaceSlug)}/index`,
    null,
    { params },
  )
  return response.data
}
